module.exports = __webpack_public_path__ + "img/04-3-1简单.57ed028d.svg";